module.exports = __webpack_public_path__ + "img/password.34395c34.png";